import httpClient from './httpClient';
import type { PaginatedResult } from '@/types';
import type {
  UnitOfMeasure,
  ProductListItem,
  ProductDetail,
  ProductSearchItem,
  ProductFilters,
  CreateUnitRequest,
  UpdateUnitRequest,
  CreateProductRequest,
  UpdateProductRequest,
} from '@/types/dictionaries';

export const dictionariesApi = {
  // ── Units of Measure ──────────────────────────────────────

  async getUnits(): Promise<UnitOfMeasure[]> {
    const mdResponse = await httpClient.get<UnitOfMeasure[]>('/units-of-measure');
    return mdResponse.data;
  },

  // Сервер повертає Guid створеної одиниці
  async createUnit(mdRequest: CreateUnitRequest): Promise<string> {
    const mdResponse = await httpClient.post<string>('/units-of-measure', mdRequest);
    return mdResponse.data;
  },

  // Сервер відповідає 204 без тіла
  async updateUnit(mdRequest: UpdateUnitRequest): Promise<void> {
    await httpClient.put(`/units-of-measure/${mdRequest.id}`, mdRequest);
  },

  async deleteUnit(mdId: string): Promise<void> {
    await httpClient.delete(`/units-of-measure/${mdId}`);
  },

  // ── Products ──────────────────────────────────────────────

  async getProducts(mdFilters: ProductFilters): Promise<PaginatedResult<ProductListItem>> {
    const mdParams: Record<string, string | number | boolean> = {
      page: mdFilters.page,
      pageSize: mdFilters.pageSize,
    };
    if (mdFilters.search) mdParams.search = mdFilters.search;
    if (mdFilters.category) mdParams.category = mdFilters.category;
    if (mdFilters.riskClass) mdParams.riskClass = mdFilters.riskClass;
    if (mdFilters.isActive !== undefined) mdParams.isActive = mdFilters.isActive;
    if (mdFilters.hasExpiredDsmd) mdParams.hasExpiredDsmd = true;
    if (mdFilters.dsmdStatus) mdParams.dsmdStatus = mdFilters.dsmdStatus;

    const mdResponse = await httpClient.get<PaginatedResult<ProductListItem>>(
      '/products',
      { params: mdParams }
    );
    return mdResponse.data;
  },

  async getProductById(mdId: string): Promise<ProductDetail> {
    const mdResponse = await httpClient.get<ProductDetail>(`/products/${mdId}`);
    return mdResponse.data;
  },

  async searchProducts(mdQuery: string): Promise<ProductSearchItem[]> {
    const mdResponse = await httpClient.get<ProductSearchItem[]>(
      '/products/search',
      { params: { q: mdQuery } }
    );
    return mdResponse.data;
  },

  // Сервер повертає Guid створеної позиції
  async createProduct(mdRequest: CreateProductRequest): Promise<string> {
    const mdResponse = await httpClient.post<string>('/products', mdRequest);
    return mdResponse.data;
  },

  // Сервер відповідає 204 без тіла
  async updateProduct(mdRequest: UpdateProductRequest): Promise<void> {
    await httpClient.put(`/products/${mdRequest.id}`, mdRequest);
  },

  async deleteProduct(mdId: string): Promise<void> {
    await httpClient.delete(`/products/${mdId}`);
  },
};
